import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";

export function InfoTooltip({ text }: { text: string }) {
  const { t } = useTranslation("disputes");

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label={t("learn_more")}
            className="inline-flex align-middle text-muted-foreground hover:text-foreground"
            onClick={(e) => e.stopPropagation()}
          >
            <Info size={14} />
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs text-xs leading-relaxed">{text}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
